import { render, staticRenderFns } from "./PremiumMaterialsOrderForm.vue?vue&type=template&id=0e803ba4&"
import script from "./PremiumMaterialsOrderForm.vue?vue&type=script&lang=js&"
export * from "./PremiumMaterialsOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports